import { NavigateFunction } from 'react-router-dom'

import { BridgeService } from '@/services'
import { DeepLinks } from '@/services/bridge/types'

const allowedDomains: string[] = ['inter.co', 'bancointer.com.br', 'uatbi.com.br', 'com.br']
const allowedDeepLinks: string[] = ['bancointer://']

export const isValidUrlAndDeepLink = (url: string): boolean => {
  if (allowedDeepLinks.some((deepLink) => url?.startsWith(deepLink))) {
    return true
  }

  try {
    const parsedUrl = new URL(url)
    const { hostname } = parsedUrl

    return allowedDomains.some((domain) => hostname?.endsWith(domain))
  } catch (error) {
    return false
  }
}
export const handleRedirectUrlDeepLink = (value: string, navigate?: NavigateFunction) => {
  if (value?.startsWith('/') && navigate) {
    navigate({
      pathname: value,
    })
  }

  if (!isValidUrlAndDeepLink(value)) {
    return
  }

  if (value?.startsWith('https')) {
    window.location.href = value
  }

  if (value?.startsWith('bancointer')) {
    BridgeService.navigateToNativeScreen(value as DeepLinks)
  }
}
export const scrollTop = () =>
  window.scrollTo({
    top: 0,
  })
